module.exports = __webpack_public_path__ + "img/metal_aw@2x.e1a5f7bc.png";